var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"mehr-erfahren",attrs:{"to":_vm.to}},[_vm._t("default",[_vm._v("MEHR ERFAHREN")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }